import { DataAccessContext } from '@axo/shared/data-access/provider';
import { NonIdealState } from '@blueprintjs/core';
import { useContext, ReactNode, useEffect } from 'react';
import { ApplicationContext } from '../../store/context';
import {
  aceRoles,
  useAvailableMarketCountries,
} from '../../hooks/utils/useAvailableMarketCountries';

export function ResolveMarketCountryFromAuth({
  children,
}: {
  children: ReactNode;
}) {
  const { state, dispatch } = useContext(ApplicationContext);
  const countries = useAvailableMarketCountries();

  const {
    state: {
      user: { roles },
    },
  } = useContext(DataAccessContext);

  useEffect(() => {
    if (!state.marketCountry) {
      const autoCountry = countries[0];
      if (autoCountry) {
        dispatch({
          scope: { parentType: 'marketCountry' },
          type: 'Set market country',
          payload: autoCountry,
        });
      }
    }
  }, [countries, state.marketCountry, dispatch]);

  if (state.marketCountry && !countries.includes(state.marketCountry)) {
    return (
      <div
        style={{
          paddingTop: 'var(--margin-small)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'left',
        }}
      >
        <NonIdealState icon="blocked-person">
          <span>You do not have access to ACE in the selected country.</span>
          <span>
            Please select a different country or contact your manager to receive
            the required permissions.
          </span>
          <div
            style={{
              textAlign: 'left',
              width: '100%',
              border: '1px solid var(--color-light-gray1)',
              padding: 'var(--padding-xsmall)',
            }}
          >
            <h4>Your roles:</h4>
            <ul>
              {roles.map((role) => (
                <li key={`${role.Country}/${role.Name}`}>
                  <span>{role.Name}</span>
                  {role.Country && <span> ({role.Country})</span>}
                </li>
              ))}
            </ul>
            <h4>ACE roles:</h4>
            <ul>
              {aceRoles.map((role) => (
                <li key={role}>{role}</li>
              ))}
            </ul>
          </div>
        </NonIdealState>
      </div>
    );
  }

  return children;
}
